import { ApiError, useI18n } from '#imports'

/**
 * Turns a failed promotion request into copy we can show a player.
 *
 * Error text from the services can leak internals (HTTP status text, raw JSON payloads), so it
 * is never rendered. Instead the errorCode is translated when we have copy for it, otherwise
 * the generic message is used.
 */
export const usePromotionErrorMessage = () => {
    const { t, te } = useI18n()

    return (error?: unknown) => {
        const errorCode = ApiError.isError(error) ? error.data?.errorCode : undefined
        const key = errorCode ? `promotions.errors.${errorCode}` : ''

        return key && te(key) ? t(key) : t('promotions.errors.P:0001')
    }
}
